import { Trans, useLingui } from '@lingui/react/macro'
import { Button, Modal, Stack } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import { getTermsVersion } from './contractTermsVersions'

interface ContractTermsModalProps {
  opened: boolean
  onClose: () => void
  termsVersion?: string | null
}

export function ContractTermsModal({
  opened,
  onClose,
  termsVersion,
}: ContractTermsModalProps) {
  const { t } = useLingui()
  const terms = getTermsVersion(termsVersion)

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t`Contract terms – Markku.fi Home Services`}
      size="xl"
      centered
    >
      <Stack gap="md">
        {terms.content}

        <Button
          component="a"
          href={terms.pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="light"
          leftSection={<IconDownload size={16} />}
          fullWidth
          mt="md"
        >
          <Trans>Download contract terms (PDF)</Trans>
        </Button>

        <Button fullWidth onClick={onClose} color="brandOrange">
          <Trans>Close</Trans>
        </Button>
      </Stack>
    </Modal>
  )
}
